import { activity } from '@/i18n/messages/en/activity.ts'
import { admin } from '@/i18n/messages/en/admin/index.ts'
import { approvals } from '@/i18n/messages/en/approvals.ts'
import { brand } from '@/i18n/messages/en/brand.ts'
import { chat } from '@/i18n/messages/en/chat.ts'
import { common } from '@/i18n/messages/en/common.ts'
import { errors } from '@/i18n/messages/en/errors/index.ts'
import { feedback } from '@/i18n/messages/en/feedback.ts'
import { governance } from '@/i18n/messages/en/governance.ts'
import { groups } from '@/i18n/messages/en/groups.ts'
import { home } from '@/i18n/messages/en/home.ts'
import { knowledge } from '@/i18n/messages/en/knowledge.ts'
import { knowledgeFolders } from '@/i18n/messages/en/knowledgeFolders.ts'
import { login } from '@/i18n/messages/en/login.ts'
import { marketplace } from '@/i18n/messages/en/marketplace/index.ts'
import { memory } from '@/i18n/messages/en/memory.ts'
import { people } from '@/i18n/messages/en/people.ts'
import { sharing } from '@/i18n/messages/en/sharing.ts'
import { shell } from '@/i18n/messages/en/shell.ts'
import { trace } from '@/i18n/messages/en/trace.ts'

/**
 * The source catalogue, and the type.
 *
 * `Messages = typeof en` is the completeness guarantee this whole PRD rests on (LOC-011).
 * Every other locale declares itself `: Messages`, so a missing key, an extra key or a
 * function whose parameters drifted fails `bun run typecheck` rather than rendering a blank
 * or falling back at runtime. There is deliberately NO per-key runtime fallback anywhere in
 * the product (D-16) — a fallback is a silent gap, and this PRD's claim is that there are
 * none.
 *
 * One file per surface, which is also the parallelisation seam: two people translating two
 * namespaces never touch the same file, and this aggregator is the only shared one.
 */
export const en = {
  activity,
  admin,
  approvals,
  brand,
  chat,
  common,
  errors,
  feedback,
  governance,
  groups,
  home,
  knowledge,
  knowledgeFolders,
  login,
  marketplace,
  memory,
  people,
  sharing,
  shell,
  trace
}

export type Messages = typeof en
